import { useEffect, useRef } from "react";
import { init } from "pell";
import "pell/dist/pell.min.css";

// If your bundler can't import the CSS, comment the line above
// and use the minimal CSS snippet further down.

export default function PellEditor({
  value = "",
  onChange,
  placeholder = "Write something...",
  readOnly = false,
}) {
  const rootRef = useRef(null);
  const editorRef = useRef(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!rootRef.current || initializedRef.current) return;

    initializedRef.current = true;

    const pell = init({
      element: rootRef.current,
      defaultParagraphSeparator: "p",
      styleWithCSS: true,
      onChange: (html) => {
        onChange?.(html);
      },
      actions: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "heading1",
        "heading2",
        "paragraph",
        "quote",
        "olist",
        "ulist",
        "code",
        "line",
        "link",
        // If you want images, add "image" (see note below)
        // "image",
      ],
    });

    editorRef.current = pell;

    // Set initial HTML
    const contentEl = rootRef.current.querySelector(".pell-content");
    if (contentEl) {
      contentEl.innerHTML = value || "";
      contentEl.setAttribute("contenteditable", String(!readOnly));
      contentEl.setAttribute("data-placeholder", placeholder);
    }
  }, [onChange, placeholder, readOnly, value]);

  // Keep editor in sync if parent updates `value`
  useEffect(() => {
    if (!rootRef.current) return;
    const contentEl = rootRef.current.querySelector(".pell-content");
    if (!contentEl) return;

    // Only update if different, so we don't nuke cursor position constantly
    if ((contentEl.innerHTML || "") !== (value || "")) {
      contentEl.innerHTML = value || "";
    }
  }, [value]);

  // Toggle readOnly dynamically
  useEffect(() => {
    if (!rootRef.current) return;
    const contentEl = rootRef.current.querySelector(".pell-content");
    if (!contentEl) return;
    contentEl.setAttribute("contenteditable", String(!readOnly));
  }, [readOnly]);

  return <div ref={rootRef} />;
}